module.exports = __webpack_public_path__ + "static/media/stops.7ace5481.svg";